const loadImg = (src) =>
    new Promise((res, rej) => {
        const i = new Image();
        i.onload = () => res(i);
        i.onerror = rej;
        i.src = src;
    });

export async function shareScoreCard(score, username) {
    const W = 1080;
    const H = 1350;
    const canvas = document.createElement("canvas");
    canvas.width = W;
    canvas.height = H;
    const ctx = canvas.getContext("2d");

    const bg = await loadImg("/assets/asset1.png");
    const scale = Math.max(W / bg.width, H / bg.height);
    const dw = bg.width * scale;
    const dh = bg.height * scale;
    ctx.drawImage(bg, (W - dw) / 2, (H - dh) / 2, dw, dh);

    const gr = ctx.createLinearGradient(0, H * 0.3, 0, H);
    gr.addColorStop(0, "rgba(6,6,8,0)");
    gr.addColorStop(0.55, "rgba(6,6,8,0.55)");
    gr.addColorStop(1, "rgba(6,6,8,0.95)");
    ctx.fillStyle = gr;
    ctx.fillRect(0, 0, W, H);

    if (document.fonts?.load) {
        await document.fonts.load('96px "Press Start 2P"');
    }
    ctx.textAlign = "center";
    ctx.fillStyle = "#F2F2F7";
    ctx.font = '40px "Press Start 2P"';
    ctx.fillText("HIGH SCORE", W / 2, H * 0.42);

    ctx.fillStyle = "#FFD60A";
    ctx.font = '96px "Press Start 2P"';
    ctx.fillText(String(score), W / 2, H * 0.51);

    if (username) {
        ctx.fillStyle = "#38BDF8";
        ctx.font = '34px "Press Start 2P"';
        ctx.fillText(`@${username.toUpperCase()}`, W / 2, H * 0.565);
    }

    try {
        const logo = await loadImg("/assets/asset2.png");
        const lw = 430;
        const lh = (lw * logo.height) / logo.width;
        ctx.drawImage(logo, (W - lw) / 2, H * 0.62, lw, lh);
    } catch (e) { /* logo optional */ }

    ctx.fillStyle = "#F2F2F7";
    ctx.font = '26px "Press Start 2P"';
    ctx.fillText("GRILL ENFORCERS — FLIP THE PATTY", W / 2, H * 0.9);
    ctx.fillStyle = "#A1A1B2";
    ctx.font = '22px "Press Start 2P"';
    ctx.fillText("DM @GRILL_ENFORCERS TO ORDER — $40", W / 2, H * 0.94);

    const blob = await new Promise((r) => canvas.toBlob(r, "image/png"));
    const file = new File([blob], "grill-enforcers-score.png", { type: "image/png" });
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
            files: [file],
            title: "Grill Enforcers — Patty Flip",
            text: `I scored ${score} in Patty Flip! @grill_enforcers`,
        });
    } else {
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = "grill-enforcers-score.png";
        a.click();
        setTimeout(() => URL.revokeObjectURL(a.href), 4000);
    }
}
